import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { Sparkle } from "./Sparkle";

const GROUPS = {
    en: [
        {
            title: "Research",
            items: [
                "Interviews",
                "Surveys",
                "Usability testing",
                "Expert reviews",
            ],
        },
        {
            title: "Design",
            items: [
                "UX flows",
                "Wireframes",
                "Prototypes",
                "UI",
                "Design systems",
            ],
        },
        {
            title: "Tools",
            items: [
                "Figma",
                "Miro",
                "Illustrator",
                "InDesign",
                "HTML / CSS",
            ],
        },
        {
            title: "AI Literacy",
            note: "Continuously learning — I follow the field weekly.",
            items: [
                "AI-assisted design",
                "Prompt design",
                "ChatGPT · Claude · Gemini",
                "AI research synthesis",
            ],
        },
    ],
    nl: [
        {
            title: "Research",
            items: [
                "Interviews",
                "Surveys",
                "Usability testing",
                "Expert reviews",
            ],
        },
        {
            title: "Design",
            items: [
                "UX flows",
                "Wireframes",
                "Prototypes",
                "UI",
                "Design systems",
            ],
        },
        {
            title: "Tools",
            items: [
                "Figma",
                "Miro",
                "Illustrator",
                "InDesign",
                "HTML / CSS",
            ],
        },
        {
            title: "AI-geletterdheid",
            note: "Continu bijleren — ik volg het veld wekelijks.",
            items: [
                "AI-assisted design",
                "Prompt design",
                "ChatGPT · Claude · Gemini",
                "AI research synthesis",
            ],
        },
    ],
};

export const Skills = () => {
    const { t, lang } = useLanguage();

    return (
        <section id="skills" data-testid="skills-section" className="relative">
            <div className="max-w-[1320px] mx-auto px-6 lg:px-12 py-16 lg:py-20">
                {/* Header */}
                <div className="grid lg:grid-cols-12 gap-8 items-end mb-14">
                    <div className="lg:col-span-7">
                        <div
                            className="font-mono-archive text-[11px] mb-4 inline-flex items-center gap-2"
                            style={{ color: "var(--muted-ink)" }}
                        >
                            <Sparkle size={12} />
                            {t("skills.eyebrow")}
                        </div>
                        <h2
                            className="font-serif-display text-[40px] sm:text-[54px] lg:text-[64px] leading-[1.02]"
                            style={{ color: "var(--ink)" }}
                        >
                            {t("skills.title.a")}
                            <span
                                className="italic"
                                style={{ color: "var(--yellow-deep)" }}
                            >
                                {t("skills.title.b")}
                            </span>
                            {t("skills.title.c")}
                        </h2>
                    </div>
                    <p
                        className="lg:col-span-5 text-[15.5px] leading-[1.65]"
                        style={{ color: "var(--ink-soft)" }}
                    >
                        {t("skills.intro")}
                    </p>
                </div>

                {/* Clean typographic grouped list */}
                <div
                    data-testid="toolkit-panel"
                    className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 sm:gap-10 pt-2"
                    style={{ borderTop: "1px solid var(--line)" }}
                >
                    {GROUPS[lang].map((group, idx) => (
                        <div
                            key={group.title}
                            data-testid={`toolkit-group-${group.title.toLowerCase().replace(/\s+/g, "-")}`}
                            className="pt-8"
                        >
                            <div
                                className="font-mono-archive text-[10.5px] mb-5 uppercase tracking-[0.22em]"
                                style={{
                                    color:
                                        group.title.toLowerCase().includes("ai")
                                            ? "var(--yellow-deep)"
                                            : "var(--muted-ink)",
                                }}
                            >
                                {String(idx + 1).padStart(2, "0")} — {group.title}
                            </div>
                            <ul className="space-y-2.5">
                                {group.items.map((item) => (
                                    <li
                                        key={item}
                                        className="font-serif-display text-[20px] sm:text-[22px] leading-[1.25]"
                                        style={{ color: "var(--ink)" }}
                                    >
                                        {item}
                                    </li>
                                ))}
                            </ul>
                            {group.note && (
                                <p
                                    className="mt-4 font-serif-display italic text-[13.5px] leading-[1.55]"
                                    style={{ color: "var(--muted-ink)" }}
                                >
                                    {group.note}
                                </p>
                            )}
                        </div>
                    ))}
                </div>

                <p
                    className="mt-12 font-serif-display italic text-[16px]"
                    style={{ color: "var(--muted-ink)" }}
                >
                    {lang === "nl"
                        ? "Basiservaring: JS, React, PHP, GSAP."
                        : "Working knowledge of: JS, React, PHP, GSAP."}
                </p>
            </div>
        </section>
    );
};
